import { Component, HostListener, inject } from '@angular/core';
import { Notification } from '../models/notification';
import { NotificationService } from '../services/notification.service';
import { MachineService } from '../services/machine.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Machine } from '../models/machine';
import { MatDialog } from '@angular/material/dialog';
import { NotificationComponent } from '../notification/notification.component';

@Component({
  selector: 'app-notification-list',
  templateUrl: './notification-list.component.html',
  styleUrl: './notification-list.component.scss',
  standalone: false,

})
export class NotificationListComponent {
  private machineService = inject(MachineService);
  private location = inject(Location);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private dialog = inject(MatDialog);

  loading = false;
  machineName = '';
  notifications: Notification[] = [];
  isMobileView: boolean = false;

  ngOnInit() {
    this.checkMobileView();
    this.route.paramMap.subscribe(params => {
      const machineIdParm = params.get('machineId');

      // parse machineId to number
      var machineId = machineIdParm ? parseInt(machineIdParm) : null;

      if (machineId) {
        this.loading = true;
        this.machineService.getMachineWithNotifications(machineId).subscribe((machineWithNotifications: Machine) => {
          this.machineName = machineWithNotifications.name;
          this.notifications = machineWithNotifications.notifications;

          // sort notifications by date
          this.notifications = this.notifications.sort((a, b) => {
            return new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime();
          });
          this.loading = false;
        });
      }
      else {
        this.machineName = 'Mo machine found';
      }
    });
  }
  public openNotification(notification: Notification) {
    if (this.isMobileView) {
      // Navigate to notification page on mobile
      this.router.navigate(['/notification', notification.id]);
    } else {
      // Open modal on desktop
      this.dialog.open(NotificationComponent, {
        data: notification,
        width: '720px',
        height: '60vh',
      });
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.checkMobileView();
  }

    private checkMobileView() {
    this.isMobileView = window.innerWidth <= 768;
  }

  goBack() {
    this.location.back();
  }
}
